export const storageBucket = 'kavtek-ambria-production';
